import { BaseTopMenuBloc } from "./bloc.base";

export class CloudTopMenuBloc extends BaseTopMenuBloc {

}

